import React from "react";

import { Box, Typography, Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

const useStyles = makeStyles()((theme: Theme) => ({
  days: {
    backgroundColor: colors.primary,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(1, 4),
  },
}));

type DaysProp = {
  duration: number | undefined;
};

const Days: React.FC<DaysProp> = ({ duration }) => {
  const { classes } = useStyles();
  return (
    <Box className={classes.days}>
      <Typography variant="h4" style={{ color: colors.white }}>
        {duration ?? "N/A"}
      </Typography>
      <Typography variant="h6" style={{ color: colors.white }}>
        Days
      </Typography>
    </Box>
  );
};

export default Days;
